import { ref } from "vue";

const PreviewWidthStorageKey = "logs.preview.width";

export function useLogPreviewPanel() {
    const refPreviewWidth = ref(Number(localStorage[PreviewWidthStorageKey]) || 420);
    const refPreviewFullscreen = ref(false);

    function startPreviewResize(event: MouseEvent): void {
        event.preventDefault();

        function resize(mouseEvent: MouseEvent): void {
            const maxWidth = Math.min(760, window.innerWidth - 260);
            const nextWidth = Math.max(320, Math.min(maxWidth, window.innerWidth - mouseEvent.clientX));

            refPreviewWidth.value = nextWidth;
            localStorage[PreviewWidthStorageKey] = String(nextWidth);
        }

        function stop(): void {
            window.removeEventListener("mousemove", resize);
            window.removeEventListener("mouseup", stop);
            document.body.classList.remove("log-preview-resizing");
        }

        document.body.classList.add("log-preview-resizing");
        window.addEventListener("mousemove", resize);
        window.addEventListener("mouseup", stop, { once: true });
    }

    return {
        refPreviewWidth,
        refPreviewFullscreen,
        startPreviewResize,
    };
}
